// imports
import * as THREE from "three"

// classes
import Experience from "./../Experience"

export default class Renderer
{
    constructor()
    {
        // setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.camera = this.experience.camera
        this.sizes = this.experience.sizes
        this.debug = this.experience.debug

        this.setInstance()
    }

    setInstance()
    {
        this.instanceParameters =
        {
            clearColor: "rgb(208,219,215)",

            shadowStatus: true,
            shadowType:
            {
                current: THREE.PCFSoftShadowMap,

                options:
                [
                    THREE.BasicShadowMap,
                    THREE.PCFShadowMap,
                    THREE.PCFSoftShadowMap,
                    THREE.VSMShadowMap,
                ]
            },

            toneType:
            {
                current: THREE.CineonToneMapping,

                options:
                [
                    THREE.NoToneMapping,
                    THREE.LinearToneMapping,
                    THREE.CineonToneMapping,
                    THREE.ReinhardToneMapping,
                    THREE.ACESFilmicToneMapping,
                ]
            },

            toneExposure: 1.75,

            outputType:
            {
                current: THREE.SRGBColorSpace,

                options:
                [
                    THREE.LinearSRGBColorSpace,
                    THREE.SRGBColorSpace
                ]
            }
        }

        this.instance = new THREE.WebGLRenderer( 
        {
            canvas: this.canvas,
            antialias: true,
        } )

        this.instance.setSize( this.sizes.width, this.sizes.height )
        this.instance.setPixelRatio = this.sizes.pixelRatio

        this.instance.setClearColor( this.instanceParameters.clearColor )

        this.instance.shadowMap.enabled = this.instanceParameters.shadowStatus
        this.instance.shadowMap.type = this.instanceParameters.shadowType.current

        this.instance.toneMapping = this.instanceParameters.toneType.current
        this.instance.toneMappingExposure = this.instanceParameters.toneExposure

        this.instance.outputColorSpace = this.instanceParameters.outputType.current
    }

    resize()
    {
        this.instance.setSize( this.sizes.width, this.sizes.height )
        this.instance.setPixelRatio = this.sizes.pixelRatio
    }

    update()
    {
        this.instance.render( 
            this.scene,
            this.camera.instance
        )
    }

    setDebug()
    {
        this.folder = this.debug.ui.addFolder( 
        {
            title: "Renderer",
            expanded: false,

        } ).on( "change", ( _changeInfo ) => this.handleChange( _changeInfo ) )

        this.tabs = this.folder.addTab(  
        {
            pages:
            [
                { title: "General" },
                { title: "ToneMap" },
                { title: "Shadows" },
            ]
        } )

        this.generalFolder = this.tabs.pages[0]
        this.toneMapFolder = this.tabs.pages[1]
        this.shadowsFolder = this.tabs.pages[2]

        // general
        this.generalFolder.addInput( this.instanceParameters, "clearColor" )
        this.generalFolder.addBlade(
        {
            view: "list",
            label: "outputType",

            options:
            [
                { text: "Linear", value: THREE.LinearSRGBColorSpace },
                { text: "sRBG", value: THREE.SRGBColorSpace },
            ],

            value: this.instanceParameters.outputType.current
        } )


        // toneMapping
        this.toneMapFolder.addBlade(
        {
            view: "list",
            label: "toneType",

            options:
            [
                { text: "No.", value: THREE.NoToneMapping },
                { text: "Linear", value: THREE.LinearToneMapping },
                { text: "Cineon", value: THREE.CineonToneMapping },
                { text: "Reinhard", value: THREE.ReinhardToneMapping },
                { text: "ACESFilmic", value: THREE.ACESFilmicToneMapping },
            ],

            value: this.instanceParameters.toneType.current
        } )
        this.toneMapFolder.addInput( this.instanceParameters, "toneExposure",
        {
            min: 0,
            max: 10,
            step: 0.01
        } )


        // shadows
        this.shadowsFolder.addBlade(
        {
            view: "list",
            label: "shadowStatus",

            options:
            [
                { text: "On", value: true },
                { text: "Off", value: false },
            ],

            value: this.instanceParameters.shadowStatus
        } )
        this.shadowsFolder.addBlade(
        {
            view: "list",
            label: "shadowType",

            options:
            [
                { text: "Basic", value: THREE.BasicShadowMap },
                { text: "PCF", value: THREE.PCFShadowMap },
                { text: "PCFSoft", value: THREE.PCFSoftShadowMap },
                { text: "PCF", value: THREE.PCFShadowMap },
                { text: "VSM", value: THREE.VSMShadowMap }
            ],

            value: this.instanceParameters.shadowType.current
        } )
    }

    handleChange( _changeInfo )
    {
        const label = _changeInfo.target.controller_.view.labelElement.innerText

        this.instanceParameters.outputType.current = label === "outputType" ?  _changeInfo.value : this.instanceParameters.outputType.current

        this.instanceParameters.shadowStatus = label === "shadowStatus" ? _changeInfo.value : this.instanceParameters.shadowStatus
        this.instanceParameters.shadowType.current = label === "shadowType" ? this.instanceParameters.shadowType.options[ _changeInfo.value ] : this.instanceParameters.shadowType.current
        this.instanceParameters.toneType.current = label === "toneType" ? this.instanceParameters.toneType.options[ _changeInfo.value ] : this.instanceParameters.toneType.current


        this.instance.setClearColor( this.instanceParameters.clearColor )
        this.instance.outputColorSpace = this.instanceParameters.outputType.current

        this.instance.toneMapping = this.instanceParameters.toneType.current
        this.instance.toneMappingExposure = this.instanceParameters.toneExposure

        this.instance.shadowMap.enabled = this.instanceParameters.shadowStatus
        this.instance.shadowMap.type = this.instanceParameters.shadowType.current        
    }
}